import axios from 'axios'
import environment from '@/config/environment'

const instance = axios.create({
    baseURL: environment.backendUrl,
    headers: {
        'Authorization': {
            toString() {
                return `Bearer ${localStorage.getItem('token')}`
            }
        },
        //TODO: need use in first time from userprofile from feature
        'ClientId': localStorage.getItem('ClientId') == null ? 1 : localStorage.getItem('ClientId')
    }
});

export default instance